/** SEC-ROSTER-01: подписи статуса явки (не типы абонементов). */

export const ATTENDANCE_UNKNOWN = 0;
export const ATTENDANCE_ATTENDED = 1;
export const ATTENDANCE_NO_SHOW = 2;

export function normalizeAttendanceStatus(row) {
  if (!row) return ATTENDANCE_UNKNOWN;
  const n = Number(row.attendanceStatus != null ? row.attendanceStatus : row.AttendanceStatus);
  if (n === ATTENDANCE_ATTENDED || n === ATTENDANCE_NO_SHOW) return n;
  const name = String(row.attendanceStatusName || row.AttendanceStatusName || '').toLowerCase();
  if (name === 'attended' || name === 'present') return ATTENDANCE_ATTENDED;
  if (name === 'no_show' || name === 'noshow' || name === 'absent') return ATTENDANCE_NO_SHOW;
  return ATTENDANCE_UNKNOWN;
}

export function attendanceStatusLabel(status, { sessionStarted } = {}) {
  if (status === ATTENDANCE_ATTENDED) return 'Пришёл';
  if (status === ATTENDANCE_NO_SHOW) return 'Не пришёл';
  return sessionStarted ? 'Не отмечено' : 'Ожидается';
}

export function rosterPersonLabel(row) {
  if (!row) return '';
  const name = row.userName || row.UserName || '';
  const phone = row.userPhone || row.UserPhone || '';
  const email = row.userEmail || row.UserEmail || '';
  const id = row.userId != null ? row.userId : row.UserId;
  const parts = [name, phone, email].filter(Boolean);
  return parts.join(' · ') || `User #${id != null ? id : '?'}`;
}

/**
 * Ответ GET roster нельзя применять, если диалог уже закрыт, сменилось занятие
 * или поколение загрузки устарело (открыли A, затем B).
 */
export function isOccurrenceRosterResponseStale({
  requestedOccurrenceId,
  requestedSectionId,
  currentDialog,
  dialogOpen,
  loadEpoch,
  currentEpoch,
} = {}) {
  if (loadEpoch !== currentEpoch) return true;
  if (!dialogOpen || !currentDialog) return true;
  if (currentDialog.kind === 'personal_training') return true;
  if (Number(currentDialog.id) !== Number(requestedOccurrenceId)) return true;
  if (
    requestedSectionId != null &&
    currentDialog.sectionId != null &&
    Number(currentDialog.sectionId) !== Number(requestedSectionId)
  ) {
    return true;
  }
  return false;
}
